// extracted by mini-css-extract-plugin
export default {"root":"_2SoSoX9o","label":"_3CfGgkKz","text":"_3ZSKUoR_","input":"_2d_-Iuzs"};